// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BR98","colBig":"styles_colBig__24Fd9","colSmall":"styles_colSmall__1FrTs"};